<div class="container-fluid" *ngIf="currentUser">
    <fap-layout></fap-layout>
</div>